<template>
  <div class="content-stacked-bar-chart col-12">
    <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 mb-15 offset-md-2 offset-sm-1">
      <div class="content-stacked-bar-chart__header">
        <h3>{{ content.title }}</h3>

        <p>{{ content.subtitle }}</p>

        <div class="stacked-bar-chart-header__controls">
          <select-filter-alt
            v-model="selectedQuestion"
            :selections="questionList"
            :fluid="true"
            @input="handleUpdate"
            :label-icon="true"
            style="margin: 0px !important"
            tagging-attr="visualization3"
          />

          <div class="stacked-bar-chart-header__legend">
            <div class="stackedbar-legend">
              <p
                :class="['legend-item text-legend', legendType]"
                v-for="legend in legends[legendType]"
                :key="legend.label"
              >
                <span :style="{ backgroundColor: legend.color }" />
                {{ legend.label }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- chart here -->
    <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1 mb-15 offset-sm-1 offset-md-1">
      <div class="row">
        <div class="content-stacked-bar-chart__chart col-xs-12 col-sm-6" v-for="n in countries" :key="n">
          <p class="text-legend font-weight-bold mb-5">{{ n }}</p>
          <StackedBarChartViz :question="selectedQuestion" :country="n" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFilterAlt from '@/components/ui/SelectFilterAlt.vue';

export default {
  name: 'StackedBarChart',
  components: {
    SelectFilterAlt,
    StackedBarChartViz: () => import('@/components/content/chapter2/charts/StackedBarChartViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    legendType() {
      return this.selectedQuestion === 'How often do they use it?' ? 'frequency' : 'y/n';
    },
  },
  data() {
    return {
      loadedData: [],
      selectedCountry: 'ASEAN-6',
      countries: ['ASEAN-6', 'Indonesia', 'Malaysia', 'Philippines', 'Singapore', 'Thailand', 'Vietnam'],
      selectedQuestion: 'Are consumers aware of embedded finance apps?',
      questionList: [
        'Are consumers aware of embedded finance apps?',
        'Have they used such an app?',
        'How often do they use it?',
      ],
      legends: {
        frequency: [
          { label: 'Every day', color: '#004A91' },
          { label: 'Several times a week', color: '#005EB8' },
          { label: 'Once a week', color: '#437CC7' },
          { label: 'Once in two weeks', color: '#6BA0E0' },
          { label: 'Once a month', color: '#93C1F7' },
          { label: 'Do not use regularly', color: '#B6D6FB' },
          { label: 'Never', color: '#D2E4FA' },
        ],
        'y/n': [
          { label: 'Yes', color: '#005EB8' },
          { label: 'No', color: '#FDC4D0' },
        ],
      },
    };
  },
  methods: {
    loadCountries(data) {
      this.countries = data.map((d) => d.key);
    },
    handleUpdate(country) {
      this.selectedCountry = country;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-stacked-bar-chart {
  background-color: #ffffff;
  padding: 60px 0;

  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }

  &__header {
    margin-bottom: 30px;
  }

  &__chart {
    @media #{map-get($media-breakpoints, 'mobile')} {
      margin-bottom: 15px;
    }
    margin-bottom: 20px;
  }

  .stackedbar-legend {
    margin-top: 20px;

    p.legend-item {
      display: inline-block;
      margin-right: 24px;

      span {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        margin-bottom: 3px;
        border-radius: 3px;
      }
    }

    p.legend-item.frequency {
      min-width: 154px;
    }
  }
}

.mb-5 {
  margin-bottom: 5px;
}

@media #{map-get($media-breakpoints, 'mobile')} {
  .content-stacked-bar-chart__header {
    margin-bottom: 15px;
  }
}
</style>
